<template>
    <form>
        <div class="row">
            <div class="col-lg-7">
                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.document_upload__application_template_card_title"
                        )
                    }}
                </h4>
                <a
                    :href="downloadFiles[0][$i18n.locale]"
                    class="ml-2 btn btn-simple btn-primary"
                >
                    {{
                        $t(
                            "small_technical_grants_assessments.document_upload__download_template_button_title"
                        )
                    }}
                    <i class="tim-icons icon-cloud-download-93 ml-2"></i>
                </a>

                <!-- <div class="row">
                    <div class="col-md-10 ml-2 mt-2">
                        <div style="border: 1px solid #90c14f; padding: 0px" class="form-group">
                            <textarea
                                style="height: 30px;"
                                class="form-control"
                                name="technical.appTemplateCVDescription"
                                v-model="GrantForm.model.technical.appTemplateCVDescription"
                                :error="getError('technical.appTemplateCV')"
                                :placeholder="
                                    $t(
                                        'small_technical_grants_assessments.document_upload__document_description_upload_placeholder'
                                    )
                                "
                            >
                            </textarea>
                        </div>
                    </div>
                </div>  -->

                <div class="form-group">
                    <span
                        class="file-caption"
                        v-if="!GrantForm.files.technical.appTemplateCV"
                        >{{
                            $t(
                                "small_technical_grants_assessments.document_upload__staffs_cv_upload_title"
                            )
                        }}</span
                    >
                    <upload-file
                        v-if="GrantForm.initialized"
                        v-model="GrantForm.files.technical.appTemplateCV"
                        class="upload-file"
                        :file-data="GrantForm.files.technical.appTemplateCV"
                        :is-editable="GrantForm.isEditable"
                        :size-limit="GrantForm.fileSizeLimit"
                        section="technical.appTemplateCV"
                    >
                    </upload-file>
                </div>

                <!-- New Download logical framework template-->
                <h6>
                    {{
                        $t(
                            "small_technical_grants_assessments.document_upload__logical_framework_card_title"
                        )
                    }}
                </h6>
                <a
                    :href="downloadFiles[3][$i18n.locale]"
                    class="ml-2 btn btn-simple btn-primary"
                >
                    {{
                        $t(
                            "small_technical_grants_assessments.document_upload__download_template_button_title"
                        )
                    }}
                    <i class="tim-icons icon-cloud-download-93 ml-2"></i>
                </a>

                <!-- <div class="row">
                    <div class="col-md-10 ml-2 mt-2">
                        <div style="border: 1px solid #90c14f; padding: 0px" class="form-group">
                            <textarea
                                style="height: 30px;"
                                class="form-control"
                                name="technical.logicalFrameworkDescription"
                                v-model="GrantForm.model.technical.logicalFrameworkDescription"
                                :error="getError('technical.logicalFramework')"
                                :placeholder="
                                    $t(
                                        'small_technical_grants_assessments.document_upload__document_description_upload_placeholder'
                                    )
                                "
                            >
                    </textarea>
                        </div>
                    </div>
                </div> -->

                <div class="form-group">
                    <span
                        class="file-caption"
                        v-if="!GrantForm.files.technical.logicalFramework"
                        >{{
                            $t(
                                "small_technical_grants_assessments.document_upload__logical_framework_upload_title"
                            )
                        }}</span
                    >
                    <upload-file
                        v-if="GrantForm.initialized"
                        v-model="GrantForm.files.technical.logicalFramework"
                        class="upload-file"
                        :file-data="GrantForm.files.technical.logicalFramework"
                        :is-editable="GrantForm.isEditable"
                        :size-limit="GrantForm.fileSizeLimit"
                        section="technical.logicalFramework"
                    >
                    </upload-file>
                </div>


                <!-- New -->

                <div class="row">
                    <div class="col-lg-12 mt-4 mb-4">
                        <h4 class="card-title">
                            {{
                                $t(
                                    "small_technical_grants_assessments.document_upload__other_staff_cvs_card_title"
                                )
                            }}
                        </h4>
                        <table class="mb-2" width="100%">
                            <thead>
                                <th>Name</th>
                                <th width="140">&nbsp;</th>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(item, index) in GrantForm.model.technical
                                        .staffCVs"
                                    :key="'staff_cv_' + index"
                                >
                                    <td>
                                        <textarea
                                            class="form-control"
                                            :placeholder="
                                                $t(
                                                    'small_technical_grants_assessments.document_upload__other_staff_cvs_placeholder'
                                                )
                                            "
                                            v-model="item.result"
                                        >
                                        </textarea>
                                    </td>
                                    <td>
                                        <upload-file
                                            v-if="GrantForm.initialized"
                                            v-model="
                                                GrantForm.files.technical[
                                                    'staffCVs' + (index + 1)
                                                ]
                                            "
                                            class="upload-file"
                                            :file-data="
                                                GrantForm.files.technical[
                                                    'staffCVs' + (index + 1)
                                                ]
                                            "
                                            :is-editable="GrantForm.isEditable"
                                            :size-limit="GrantForm.fileSizeLimit"
                                            :section="
                                                'technical.staffCVs' + (index + 1)
                                            "
                                        >
                                        </upload-file>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <base-button
                            type="primary"
                            @click.native="addStaffCVs"
                            class="ml-2"
                        >
                            <i class="tim-icons icon-simple-add mr-2"></i>
                            {{
                                $t(
                                    "small_technical_grants_assessments.logical_framework__add_row_button_title"
                                )
                            }}
                        </base-button>
                        <span class="ml-3">{{
                            $t(
                                "small_technical_grants_assessments.logical_framework__add_row_button_info"
                            )
                        }}</span>
                    </div>
                </div>

                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.document_upload__applicant_declaration_card_title"
                        )
                    }}
                </h4>
                <a
                    :href="downloadFiles[1][$i18n.locale]"
                    class="ml-2 btn btn-simple btn-primary"
                >
                    {{
                        $t(
                            "small_technical_grants_assessments.document_upload__download_template_button_title"
                        )
                    }}
                    <i class="tim-icons icon-cloud-download-93 ml-2"></i>
                </a>

                <!-- <div class="row">
                    <div class="col-md-10 ml-2 mt-2">
                        <div style="border: 1px solid #90c14f; padding: 0px" class="form-group">
                            <textarea
                                style="height: 30px;"
                                class="form-control"
                                name="technical.appDeclarationDescription"
                                v-model="GrantForm.model.technical.appDeclarationDescription"
                                :error="getError('technical.appDeclaration')"
                                :placeholder="
                                    $t(
                                        'small_technical_grants_assessments.document_upload__document_description_upload_placeholder'
                                    )
                                "
                            >
                    </textarea>
                        </div>
                    </div>
                </div> -->

                <div class="form-group">
                    <span
                        class="file-caption"
                        v-if="!GrantForm.files.technical.appDeclaration"
                        >{{
                            $t(
                                "small_technical_grants_assessments.document_upload__declaration_signed_upload_title"
                            )
                        }}</span
                    >
                    <upload-file
                        v-if="GrantForm.initialized"
                        v-model="GrantForm.files.technical.appDeclaration"
                        class="upload-file"
                        :file-data="GrantForm.files.technical.appDeclaration"
                        :is-editable="GrantForm.isEditable"
                        :size-limit="GrantForm.fileSizeLimit"
                        section="technical.appDeclaration"
                    >
                    </upload-file>
                </div>


                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.document_upload__co_applicant_mandate_card_title"
                        )
                    }}
                </h4>
                <a
                    :href="downloadFiles[2][$i18n.locale]"
                    class="ml-2 btn btn-simple btn-primary"
                >
                    {{
                        $t(
                            "small_technical_grants_assessments.document_upload__download_template_button_title"
                        )
                    }}
                    <i class="tim-icons icon-cloud-download-93 ml-2"></i>
                </a>

                <!-- <div class="row">
                    <div class="col-md-10 ml-2 mt-2">
                        <div style="border: 1px solid #90c14f; padding: 0px" class="form-group">
                            <textarea
                                style="height: 30px;"
                                class="form-control"
                                name="technical.appCoApplicantMandateDescription"
                                v-model="GrantForm.model.technical.appCoApplicantMandateDescription"
                                :error="getError('technical.appCoApplicantMandate')"
                                :placeholder="
                                    $t(
                                        'small_technical_grants_assessments.document_upload__document_description_upload_placeholder'
                                    )
                                "
                            >
                    </textarea>
                        </div>
                    </div>
                </div> -->

                <div class="form-group">
                    <span
                        class="file-caption"
                        v-if="!GrantForm.files.technical.appCoApplicantMandate"
                        >{{
                            $t(
                                "small_technical_grants_assessments.document_upload__co_applicant_mandate_upload_title"
                            )
                        }}</span
                    >
                    <upload-file
                        v-if="GrantForm.initialized"
                        v-model="
                            GrantForm.files.technical.appCoApplicantMandate
                        "
                        class="upload-file"
                        :file-data="
                            GrantForm.files.technical.appCoApplicantMandate
                        "
                        :is-editable="GrantForm.isEditable"
                        :size-limit="GrantForm.fileSizeLimit"
                        section="technical.appCoApplicantMandate"
                    >
                    </upload-file>
                </div>


                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.document_upload__due_diligence_questionnaire_card_title"
                        )
                    }}
                </h4>
                <a
                    :href="downloadFiles[4][$i18n.locale]"
                    class="ml-2 btn btn-simple btn-primary"
                >
                    {{
                        $t(
                            "small_technical_grants_assessments.document_upload__download_template_button_title"
                        )
                    }}
                    <i class="tim-icons icon-cloud-download-93 ml-2"></i>
                </a>

                <!-- <div class="row">
                    <div class="col-md-10 ml-2 mt-2">
                        <div style="border: 1px solid #90c14f; padding: 0px" class="form-group">
                            <textarea
                                style="height: 30px;"
                                class="form-control"
                                name="technical.appDueDiligenceQuestionnaireDescription"
                                v-model="GrantForm.model.technical.appDueDiligenceQuestionnaireDescription"
                                :error="getError('technical.appDueDiligenceQuestionnaire')"
                                :placeholder="
                                    $t(
                                        'small_technical_grants_assessments.document_upload__document_description_upload_placeholder'
                                    )
                                "
                            >
                    </textarea>
                        </div>
                    </div>
                </div> -->

                <div class="form-group">
                    <span
                        class="file-caption"
                        v-if="
                            !GrantForm.files.technical
                                .appDueDiligenceQuestionnaire
                        "
                        >{{
                            $t(
                                "small_technical_grants_assessments.document_upload__due_diligence_questionnaire_upload_title"
                            )
                        }}</span
                    >
                    <upload-file
                        v-if="GrantForm.initialized"
                        v-model="
                            GrantForm.files.technical
                                .appDueDiligenceQuestionnaire
                        "
                        class="upload-file"
                        :file-data="
                            GrantForm.files.technical
                                .appDueDiligenceQuestionnaire
                        "
                        :is-editable="GrantForm.isEditable"
                        :size-limit="GrantForm.fileSizeLimit"
                        section="technical.appDueDiligenceQuestionnaire"
                    >
                    </upload-file>
                </div>


                <h6>
                    {{
                        $t(
                            "small_technical_grants_assessments.document_upload__due_diligence_questionnaire_assoc_title"
                        )
                    }}
                </h6>
                <div class="form-group">
                    <span
                        class="file-caption"
                        v-if="
                            !GrantForm.files.technical.appIncorporationArticles
                        "
                        >{{
                            $t(
                                "small_technical_grants_assessments.document_upload__due_diligence_questionnaire_assoc_upload_title_1"
                            )
                        }}</span
                    >
                    <upload-file
                        v-if="GrantForm.initialized"
                        v-model="
                            GrantForm.files.technical.appIncorporationArticles
                        "
                        class="upload-file"
                        :file-data="
                            GrantForm.files.technical.appIncorporationArticles
                        "
                        :is-editable="GrantForm.isEditable"
                        :size-limit="GrantForm.fileSizeLimit"
                        section="technical.appIncorporationArticles"
                    >
                    </upload-file>
                </div>
                <div class="form-group">
                    <span
                        class="file-caption"
                        v-if="
                            !GrantForm.files.technical.appInCountryRegistration
                        "
                        >{{
                            $t(
                                "small_technical_grants_assessments.document_upload__due_diligence_questionnaire_assoc_upload_title_2"
                            )
                        }}</span
                    >
                    <upload-file
                        v-if="GrantForm.initialized"
                        v-model="
                            GrantForm.files.technical.appInCountryRegistration
                        "
                        class="upload-file"
                        :file-data="
                            GrantForm.files.technical.appInCountryRegistration
                        "
                        :is-editable="GrantForm.isEditable"
                        :size-limit="GrantForm.fileSizeLimit"
                        section="technical.appInCountryRegistration"
                    >
                    </upload-file>
                </div>
                <div class="form-group">
                    <span
                        class="file-caption"
                        v-if="!GrantForm.files.technical.appTaxCertification"
                        >{{
                            $t(
                                "small_technical_grants_assessments.document_upload__due_diligence_questionnaire_assoc_upload_title_3"
                            )
                        }}</span
                    >
                    <upload-file
                        v-if="GrantForm.initialized"
                        v-model="GrantForm.files.technical.appTaxCertification"
                        class="upload-file"
                        :file-data="
                            GrantForm.files.technical.appTaxCertification
                        "
                        :is-editable="GrantForm.isEditable"
                        :size-limit="GrantForm.fileSizeLimit"
                        section="technical.appTaxCertification"
                    >
                    </upload-file>
                </div>
                <div class="form-group">
                    <span
                        class="file-caption"
                        v-if="!GrantForm.files.technical.appLastActivityReport"
                        >{{
                            $t(
                                "small_technical_grants_assessments.document_upload__due_diligence_questionnaire_assoc_upload_title_4"
                            )
                        }}</span
                    >
                    <upload-file
                        v-if="GrantForm.initialized"
                        v-model="
                            GrantForm.files.technical.appLastActivityReport
                        "
                        class="upload-file"
                        :file-data="
                            GrantForm.files.technical.appLastActivityReport
                        "
                        :is-editable="GrantForm.isEditable"
                        :size-limit="GrantForm.fileSizeLimit"
                        section="technical.appLastActivityReport"
                    >
                    </upload-file>
                </div>
                <div class="form-group">
                    <span
                        class="file-caption"
                        v-if="
                            !GrantForm.files.technical
                                .appAnualFinancialStataments
                        "
                        >{{
                            $t(
                                "small_technical_grants_assessments.document_upload__due_diligence_questionnaire_assoc_upload_title_5"
                            )
                        }}</span
                    >
                    <upload-file
                        v-if="GrantForm.initialized"
                        v-model="
                            GrantForm.files.technical
                                .appAnualFinancialStataments
                        "
                        class="upload-file"
                        :file-data="
                            GrantForm.files.technical
                                .appAnualFinancialStataments
                        "
                        :is-editable="GrantForm.isEditable"
                        :size-limit="GrantForm.fileSizeLimit"
                        section="technical.appAnualFinancialStataments"
                    >
                    </upload-file>
                </div>
                <div class="form-group">
                    <span
                        class="file-caption"
                        v-if="
                            !GrantForm.files.technical.appCodeOfConductPolicies
                        "
                        >{{
                            $t(
                                "small_technical_grants_assessments.document_upload__due_diligence_questionnaire_assoc_upload_title_6"
                            )
                        }}</span
                    >
                    <upload-file
                        v-if="GrantForm.initialized"
                        v-model="
                            GrantForm.files.technical.appCodeOfConductPolicies
                        "
                        class="upload-file"
                        :file-data="
                            GrantForm.files.technical.appCodeOfConductPolicies
                        "
                        :is-editable="GrantForm.isEditable"
                        :size-limit="GrantForm.fileSizeLimit"
                        section="technical.appCodeOfConductPolicies"
                    >
                    </upload-file>
                </div>

                <!-- <div class="row">
                    <div class="col-md-10 ml-2 mt-2">
                        <div style="border: 1px solid #90c14f; padding: 0px;" class="form-group">
                            <textarea
                                style="height: 40px;"
                                class="form-control"
                                name="technical.asociatedDocumentsDescription"
                                v-model="GrantForm.model.technical.asociatedDocuments"
                                :error="getError('technical.asociatedDocuments')"
                                :placeholder="
                                    $t(
                                        'small_technical_grants_assessments.document_upload__document_description_upload_placeholder'
                                    )
                                "
                            >
                            </textarea>
                        </div>
                    </div>
                </div> -->

                <h6 style="color: red">
                    {{
                        $t(
                            "small_technical_grants_assessments.document_upload__additional_info"
                        )
                    }}
                </h6>

                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.document_upload__budget_card_title"
                        )
                    }}
                </h4>
                <a
                    :href="downloadFiles[5][$i18n.locale]"
                    class="ml-2 btn btn-simple btn-primary"
                >
                    {{
                        $t(
                            "small_technical_grants_assessments.document_upload__download_template_button_title"
                        )
                    }}
                    <i class="tim-icons icon-cloud-download-93 ml-2"></i>
                </a>

                <!-- <div class="row">
                    <div class="col-md-10 ml-2 mt-2">
                        <div style="border: 1px solid #90c14f; padding: 0px;" class="form-group">
                            <textarea
                                style="height: 30px;"
                                class="form-control"
                                name="technical.appCompletedBudgetTableDescription"
                                v-model="GrantForm.model.technical.appCompletedBudgetTableDescription"
                                :error="getError('technical.appCompletedBudgetTable')"
                                :placeholder="
                                    $t(
                                        'small_technical_grants_assessments.document_upload__document_description_upload_placeholder'
                                    )
                                "
                            >
                    </textarea>
                        </div>
                    </div>
                </div> -->

                <div class="form-group">
                    <span
                        class="file-caption"
                        v-if="
                            !GrantForm.files.technical.appCompletedBudgetTable
                        "
                        >{{
                            $t(
                                "small_technical_grants_assessments.document_upload__budget_upload_title_1"
                            )
                        }}</span
                    >
                    <upload-file
                        v-if="GrantForm.initialized"
                        v-model="
                            GrantForm.files.technical.appCompletedBudgetTable
                        "
                        class="upload-file"
                        :file-data="
                            GrantForm.files.technical.appCompletedBudgetTable
                        "
                        :is-editable="GrantForm.isEditable"
                        :size-limit="GrantForm.fileSizeLimit"
                        section="technical.appCompletedBudgetTable"
                    >
                    </upload-file>
                </div>



            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <h4 class="card-title">
                    {{
                        $t(
                            "small_technical_grants_assessments.document_upload__other_documents_card_title"
                        )
                    }}
                </h4>
                <p>
                    {{
                        $t(
                            "small_technical_grants_assessments.document_upload__other_documents_info"
                        )
                    }}
                </p>
                <table class="mt-5 mb-2" width="100%">
                    <thead>
                        <th>Name</th>
                        <th>Upload</th>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(item, index) in GrantForm.model.technical
                                .otherDocuments"
                            :key="'result_' + index"
                        >
                            <td>
                                <textarea
                                    class="form-control"
                                    :placeholder="
                                        $t(
                                            'small_technical_grants_assessments.document_upload__other_documents_placeholder'
                                        )
                                    "
                                    v-model="item.result"
                                >
                                </textarea>
                            </td>
                            <td>
                                <upload-file
                                    v-if="GrantForm.initialized"
                                    v-model="
                                        GrantForm.files.technical[
                                            'otherDocuments' + (index + 1)
                                        ]
                                    "
                                    class="upload-file"
                                    :file-data="
                                        GrantForm.files.technical[
                                            'otherDocuments' + (index + 1)
                                        ]
                                    "
                                    :is-editable="GrantForm.isEditable"
                                    :size-limit="GrantForm.fileSizeLimit"
                                    :section="
                                        'technical.otherDocuments' + (index + 1)
                                    "
                                >
                                </upload-file>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <base-button
                    type="primary"
                    @click.native="addOtherDocument"
                    class="ml-2"
                >
                    <i class="tim-icons icon-simple-add mr-2"></i>
                    {{
                        $t(
                            "small_technical_grants_assessments.logical_framework__add_row_button_title"
                        )
                    }}
                </base-button>
                <span class="ml-3">{{
                    $t(
                        "small_technical_grants_assessments.logical_framework__add_row_button_info"
                    )
                }}</span>
            </div>
        </div>
    </form>
</template>
<script>
import { GrantForm } from "@/services";

export default {
    data() {
        return {
            GrantForm,
            downloadFiles: [
                {
                    en: "/files/en/STGA/Application_Template_STGA_2020.docx",
                    fr:
                        "/files/fr/STGA/Formulaire_Candidature_PSTE_FR_2020.docx"
                },
                {
                    en: "/files/en/STGA/Applicant_Declaration_STGA_2020.docx",
                    fr: "/files/fr/STGA/Déclaration_Demandeur_PSTE_2020.docx"
                },
                {
                    en: "/files/en/STGA/Coapplicant_Mandate_STGA-2020.docx",
                    fr: "/files/fr/STGA/Mandat_Codemandeur_PSTE_2020.docx"
                },
                {
                    en: "/files/en/STGA/STGA_Logframe_2020.xlsx",
                    fr: "/files/fr/STGA/PSTE_Cadre Logique_2020.xlsx"
                },
                {
                    en:
                        "/files/en/STGA/Due_diligence_questionnaire_STGA_EN_2020.docx",
                    fr:
                        "/files/fr/STGA/Due_diligence_questionnaire_STGA_FR_2020.docx"
                },
                {
                    en: "/files/en/STGA/STGA_budget_template_EN.xls",
                    fr: "/files/fr/STGA/PSTE_budget_Fichier_FR.xls"
                }
            ]
        };
    },
    methods: {
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        validate() {
            return this.$validator.validateAll().then(res => {
                this.$emit("on-validated", res, this.model);
                return res;
            });
        },
        addOtherDocument() {
            if (!GrantForm.model.technical.otherDocuments) {
                GrantForm.model.technical.otherDocuments = [];
            }

            GrantForm.model.technical.otherDocuments.push({});
            this.$forceUpdate();
        },
        addStaffCVs() {
            if (!GrantForm.model.technical.staffCVs) {
                GrantForm.model.technical.staffCVs = [];
            }

            GrantForm.model.technical.staffCVs.push({forceObject: true});
            this.$forceUpdate();
        },
        mounted() {
            this.addOtherDocument();
        }
    }
};
</script>
<style lang="scss" scoped>
.table-bordered td,
.table-bordered th {
    padding: 20px;
}

.file-caption {
    margin-right: 10px;
    display: inline-block;
    width: 60%;
}

.upload-file {
    display: inline-block;
    margin-bottom: -4px;
}

.form-group {
    border: 1px solid #ddd;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}

.card-title {
    display: inline-block;
    width: 54.3%;
    margin-bottom: 1.75rem !important;
}
</style>
